const List = () => import('@pages/prettyTibet/List')
const Detail = () => import('@pages/prettyTibet/List/Detail')
const Competition = () => import('@pages/prettyTibet/List/Competition')
const PrettyTibetStatement = () => import('@pages/prettyTibet/Statement')

export const prettyTibet = [
  {
    path: '/prettyTibet/list',
    name: 'PrettyTibetList',
    component: List,
    meta: {}
  },
  {
    path: '/prettyTibet/detail/:id',
    name: 'PrettyTibetDetail',
    component: Detail,
    meta: {}
  },
  {
    path: '/prettyTibet/competition',
    name: 'PrettyTibetCompetition',
    component: Competition,
    meta: {}
  },
  {
    path: '/prettyTibet/statement',
    name: 'PrettyTibetStatement',
    component: PrettyTibetStatement,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/prettyTibet.route.js